import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './sectionTextarea.scss';

import React, { Component } from 'react';

import { getData } from '@umu/umu-util';
import { components } from 'common';
const { Textarea } = components;

import {
    ESectionValid,
    ESectionType,
    ISectionBaseInfo,
    ISectionBaseResult,
    ISectionOptionBaseInfo,
    ISectionBaseExtend,
    ISectionBaseSetup,
} from '@umu/umu-types';

export interface IProps<IType, IOption, IExtend> {
    sectionInfo: ISectionBaseInfo<IType, IOption, IExtend>;
    isDisabled?: boolean;
    onValueUpdate(value: ISectionBaseResult<any>, isValid: ESectionValid): void;
}

export interface IState {
    result: ISectionBaseResult<any>;
    isValid: ESectionValid;
}

// tslint:disable-next-line:max-line-length
export default abstract class SectionTextarea<
    IP extends IProps<ESectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
    IS extends IState,
> extends Component<IP, IS> {
    // tslint:disable-next-line:max-line-length
    constructor(props: IP, state: IS) {
        super(props, state);

        const userValue = props.sectionInfo.userValue || [];
        const result = {
            userValue,
        };
        this.state = Object.assign({}, this.state, {
            result,
            isValid: this.validSection(props.sectionInfo, result),
        });
    }

    // tslint:disable-next-line:max-line-length
    public abstract validSection(
        section: ISectionBaseInfo<any, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
        result: ISectionBaseResult<any>,
    ): ESectionValid;

    public getUserValue() {
        return this.state.result;
    }

    public updateValue = (userValue: string = '') => {
        const result = {
            userValue: [userValue],
        };
        const isValid = this.validSection(this.props.sectionInfo, result);
        this.setState(
            {
                result,
                isValid,
            },
            () => {
                this.props.onValueUpdate(this.getUserValue(), isValid);
            },
        );
    };

    public render() {
        const placeholder = getData(this.props.sectionInfo, 'list', 0, 'title') || lang('请输入内容');
        return (
            <div className="section-item-body section-textarea">
                <div className="option-content">
                    <div className="input">
                        <Textarea
                            placeholder={placeholder}
                            maxLength={2000}
                            onChange={this.updateValue}
                            isDisabled={this.props.isDisabled}
                            value={this.state.result.userValue[0]}
                        ></Textarea>
                    </div>
                </div>
            </div>
        );
    }
}
